import React from 'react';
import { Form, Row, Col, Container } from "react-bootstrap";
import { customValidators, object, string, date } from '../../../Helpers/Validators/customValidators';
import { sub } from 'date-fns';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { InputMaskDate } from '../../../Helpers/Formatters';
import { SvgIcon } from '@mui/material';
import RingIcon from '../../../../icons/Ring.svg?react';
import BackNext from '../../Common/SubComponents/BackNext';
import { emptyStringToUndefined } from '../../../Helpers/Formatters/EmptyStringToUndefined.jsx';
import { TextInput, StyledRadioInput } from '../../../Helpers/Inputs';
import '../Aflac.scss';

export default function SpouseInfo(props) {

    const formMethods = useForm({
        resolver: yupResolver(SpouseInfo.ValidationSchema(props.ageSpecs)),
        mode: 'all',
        reValidateMode: 'all',
        defaultValues: props.formState
    });

    const { handleSubmit, trigger } = formMethods;

    const handleValueChange = (field, value) => {
        props.onFieldChange(field, value);
        trigger(field);
    };
    const onSubmit = () => {
        props.onNext();
    };

    const getDisabled = (props.formState.firstName === '' || props.formState.lastName === '' || props.formState.birthdate === '' || props.formState.gender === '' || props.formState.employmentStatus === '' ||
        (props.formState.employmentStatus === 'No' && props.formState.hospitalized === ''));

    return (
        <Container fluid className='border-class'>
            <Row className="justify-content-center">
                <Col>
                    <FormProvider {...formMethods}>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                            <Row className="justify-content-center mt-4">
                                <Col lg={6}>
                                    <div className="text-center mb-2 pt-4"><SvgIcon component={RingIcon} className="small-icons" color="primary" fontSize="large" /></div>
                                    <div className="text-center mb-4 form-title">Your Spouse's information</div>

                                </Col>
                            </Row>
                            <Row className="justify-content-center">
                                <Col lg={5} className='w-100'>
                                    <div className='mb-3'>
                                        <TextInput
                                            name="firstName"
                                            id="firstName"
                                            label="First Name"
                                            value={props.formState.firstName}
                                            onChange={(e) => handleValueChange('firstName', e.target.value)}
                                            inputProps={{
                                                maxLength: 20,
                                            }}
                                        />
                                    </div>

                                    <div className='mb-3'>
                                        <TextInput
                                            name="middleInitial"
                                            id="middleInitial"
                                            label="Middle Initial"
                                            value={props.formState.middleInitial}
                                            onChange={(e) => handleValueChange('middleInitial', e.target.value)}
                                            inputProps={{
                                                maxLength: 4,
                                            }}
                                        />
                                    </div>

                                    <div className='mb-3'>
                                        <TextInput
                                            name="lastName"
                                            id="lastName"
                                            label="Last Name"
                                            value={props.formState.lastName}
                                            onChange={(e) => handleValueChange('lastName', e.target.value)}
                                            inputProps={{
                                                maxLength: 50,
                                            }}
                                        />
                                    </div>

                                    <div className='mb-3'>
                                        <TextInput
                                            name="birthdate"
                                            id="birthdate"
                                            label="Date of Birth"
                                            value={props.formState.birthdate}
                                            onChange={(e) => handleValueChange('birthdate', e.target.value)}
                                            InputProps={{
                                                inputComponent: InputMaskDate,
                                            }}
                                        />
                                    </div>

                                    <div className='mb-3'>
                                        <StyledRadioInput
                                            name="gender"
                                            id="gender"
                                            value={props.formState.gender}
                                            options={[{ value: "F", label: "Female", icon: 'female' }, { value: "M", label: "Male", icon: 'male' }]}
                                            onChange={e => handleValueChange('gender', e)}
                                        />
                                    </div>

                                    <h6 className='mb-3'>Is your spouse currently reporting to work (not out on leave,FML,disability,hiatus,or layoff)?</h6>
                                    <div className='mb-3'>
                                        <StyledRadioInput
                                            name="employmentStatus"
                                            id="employmentStatus"
                                            value={props.formState.employmentStatus}
                                            options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                            onChange={e => handleValueChange('employmentStatus', e)}
                                            isWhiteBackground={true}
                                            isBlankIcon={true}
                                        />
                                    </div>

                                    {props.formState.employmentStatus === 'No' &&
                                        <div>
                                            <h6>Is your Spouse now hospitalized or unable to perform his or her normal duties and activities? </h6>
                                            <div className='mb-3'>
                                                <StyledRadioInput
                                                    name="hospitalized"
                                                    id="hospitalized"
                                                    value={props.formState.hospitalized}
                                                    options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                                    onChange={e => handleValueChange('hospitalized', e)}
                                                    isWhiteBackground={true}
                                                    isBlankIcon={true}
                                                />
                                            </div>
                                        </div>
                                    }
                                </Col>
                            </Row>
                            <div className='backnext-wrapper'>
                                <BackNext onBack={props.onBack} isAflac={true} continueLabel={{ text: "Next" }} nextDisabled={getDisabled} />
                            </div>
                        </Form>
                    </FormProvider>
                </Col>
            </Row>
        </Container>
    );
}

SpouseInfo.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func,
};

SpouseInfo.ValidationSchema = (ageSpecs) => {
    return object().shape({
        firstName: customValidators.string().isValidNameWithFiftyChar('First name is required.', true),
        middleInitial: customValidators.string().isValidNameWithFiftyChar('Middle Initials is required', false),
        lastName: customValidators.string().isValidNameWithFiftyChar('Last name is required.', true),
        birthdate: date().transform(emptyStringToUndefined).typeError('Invalid date.')
            .max(sub(new Date(), { years: ageSpecs.min, days: ageSpecs.minAgeDays || 0 }), `Product not available due to age restrictions.`)
            .min(sub(new Date(), { years: ageSpecs.max }), `Product not available due to age restrictions.`)
            .required('Birthdate is required.'),
        gender: string().required('Gender is required.'),
        employmentStatus: string().required('Employment Status is required.'),
        hospitalized: string().when('employmentStatus', {
            is: "No",
            then: (schema) => schema.required("Hospitalized Status is required."),
            otherwise: (schema) => schema.notRequired(),
        })
    })
};

SpouseInfo.DefaultFormState = (prefill = false) => {
    return {
        firstName: prefill ? 'Alex' : '',
        middleInitial: prefill ? 'Elizabeth' : '',
        lastName: prefill ? 'Smith' : "",
        birthdate: prefill ? "11/15/1980" : "",
        gender: prefill ? "F" : "",
        employmentStatus: prefill ? "Yes" : "",
        hospitalized: prefill ? "" : "",
    };
};
